module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-card"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showBullets) ? _c('div', {
    staticClass: "columns shrink align-self-middle",
    on: {
      "click": _vm.bulletsClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v fa-2x"
  })]) : _vm._e(), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns shrink"
  }, [_vm._t("header_left")], 2), _c('div', {
    staticClass: "columns"
  }, [_vm._t("header")], 2), _c('div', {
    staticClass: "columns shrink"
  }, [_vm._t("header_right")], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._t("default")], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns shrink"
  }, [_vm._t("footer_left")], 2), _c('div', {
    staticClass: "columns"
  }, [_vm._t("footer")], 2), _c('div', {
    staticClass: "columns shrink"
  }, [_vm._t("footer_right")], 2)])]), (_vm.showAction) ? _c('div', {
    staticClass: "columns shrink align-self-middle",
    on: {
      "click": _vm.actionClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15a61ff1!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Card.vue
// module id = 2232
// module chunks = 1